import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { useTranslation } from "react-i18next";

import Logo from './Logo'
import LanguageSelector from './LanguageSelector'
import Sidebar from './SideBar'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  centerSection: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  mainContainer: {
  }
}));

const MobileLayout = (props) => {
  const { t, i18n } = useTranslation('layout');
  const classes = useStyles()
  const { children } = props

  const [ isSidebarOpen, setIsSidebarOpen ] = useState(false)

  const toggleSidebar = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setIsSidebarOpen(open)
  };

  return (
    <div className={classes.root}>
      <AppBar position="sticky" color="white.main" maxHeight={50}>
        <Toolbar>
          <div className={classes.leftSection}>
            <IconButton 
              edge="start" className={classes.menuButton} color="inherit" aria-label="menu"
              onClick={toggleSidebar(!isSidebarOpen)}
            >
              <MenuIcon />
            </IconButton>
          </div>
          <div className={classes.centerSection}>
            <Logo href='/student-list'/>
          </div>
          <div className={classes.rightSection}>
            <LanguageSelector />
          </div>
        </Toolbar>
      </AppBar>
      <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}/>
      <div className={classes.mainContainer}>
        {children}
      </div>
    </div>
  );
}

export default MobileLayout

